import React from "react";
import KFC from '../Doc/Product/Kfc.png'
import plu from '../Doc/Product/plu.png'
import "./Portfolio.css";
import {ImHtmlFive} from 'react-icons/im'
import {SiCss3,SiJavascript,SiPostman,SiGithub,SiHeroku} from 'react-icons/si'
import {TbLivePhoto} from 'react-icons/tb'
export const Portfolio = () => {
  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Projects</h2>
      <div className="container portfolio__container">
        {/* First Project */}
        <article className="portfolio__item">
          <h3>Lovoda</h3>
          <div className="portfoli__item-image">
            <img src={KFC}></img>
          </div>

          <h5>
            This is a clone of E-commerce site Lovoda.comLovoda.com. Lovoda is one of the most popular online marts. Necklaces, Rings, Bracelets, etc all these types of fashionable products you can buy here.          
          </h5>

          <div className="portfolio__item-stack">
            <a className="btn2"> <ImHtmlFive/> </a>
            <a className="btn2"> <SiCss3/> </a>
            <a className="btn2"> <SiJavascript/> </a>
            <a className="btn2"> <SiPostman/> </a>
          </div>
          <div className="portfolio__item-cta">
            <a
              
              target="_blank"
              className="btn"
            >
              Github <SiGithub/>
            </a>
            <a
              href="https://deft-crepe-8bb32d.netlify.app/index.html"
              target="_blank"
              className="btn btn-primary"
            >
              Live Demo <TbLivePhoto/>
            </a>
          </div>
        </article>
        {/* Second Project */}

        <article className="portfolio__item">
          <h3>Mytheresa</h3>
          <div className="portfoli__item-image">
            <img src={plu}></img>

          </div>

          <h5>
          This website is dedicated to shopping enthusiasts, by keeping all their needs in mind. It an e-commerce website designed in its simplest form to navigate through some of the world's best brands. it gives a smooth user experience and user flow.
          </h5>

          <div className="portfolio__item-stack">
            <a className="btn2"><ImHtmlFive/> </a>
            <a className="btn2"><SiCss3/></a>
            <a className="btn2"><SiJavascript/></a>
            <a className="btn2"><SiPostman/></a>
            <a className="btn2"><SiHeroku/> </a>
          </div>
          <div className="portfolio__item-cta">
            <a
              href=""
              target="_blank"
              className="btn"
            >
              Github <SiGithub/>
            </a>
            <a
              href="https://cheery-sorbet-56415b.netlify.app/"
              target="_blank"
              className="btn btn-primary"
            >
              Live Demo <TbLivePhoto/>
            </a>
          </div>
        </article>

        {/* Third Project */}
        
      </div>
    </section>
  );
};
